<template>
    <div>
        <b-container class="main_layer py-5" fluid>
            <b-form ref="filter" autocomplete="off" class="w-100" v-on:focusin="alert = false">
                <b-container>
                    <b-row>
                        <b-col>
                            <b-row>
                                <b-col md="8">
                                    <p class="fs-52 fw-600 white-color mt-2 mb-4 less_font-size_mobile">Импортозамещение</p>
                                </b-col>
                                <b-col class="mt-2 mb-4 text-right" md="4">
                                    <router-link v-if="$store.getters.isLoggedIn" :to="{ name: 'ImportSubstitutionRequestCreate' }" class="btn btn-custom-white-orange text-uppercase" style="max-width: 210px"> Создать запрос на импортозамещение </router-link>
                                </b-col>
                            </b-row>
                            <b-row class="filter">
                                <filter-multiple-select v-model="filter.purchaseCategories" :options="$globalDictionaries.deliverableGroups" label="Предмет запроса" lg="6" md="6" placeholder="Выберите предметы запроса" />
                                <filter-input-text v-model="filter.ktruName" label="Наименование ТРУ" lg="6" md="6" placeholder="Укажите наименование ТРУ" />
                                <template v-if="showFilters">
                                    <b-col class="mb-3" cols="12" lg="3" md="6">
                                        <date-time-picker
                                            id="filter_from_purchase_start"
                                            v-model="filter.orderDateStart"
                                            :no-label="!!filter.orderDateStart"
                                            :only-date="true"
                                            autoClose
                                            buttonNowTranslation="Сегодня"
                                            class="filter_datepicker"
                                            format="YYYY-MM-DD"
                                            formatted="DD.MM.YYYY"
                                            label="Укажите дату проведения с" />
                                        <span class="fs-10 halfWhite-color">Дата проведения с...</span>
                                    </b-col>
                                    <b-col class="mb-3" cols="12" lg="3" md="6">
                                        <date-time-picker
                                            id="filter_to_purchase_start"
                                            v-model="filter.orderDateFinish"
                                            :no-label="!!filter.orderDateFinish"
                                            :only-date="true"
                                            autoClose
                                            buttonNowTranslation="Сегодня"
                                            class="filter_datepicker"
                                            format="YYYY-MM-DD"
                                            formatted="DD.MM.YYYY"
                                            label="Укажите дату проведения по" />
                                        <span class="fs-10 halfWhite-color">Дата проведения по...</span>
                                    </b-col>
                                </template>
                            </b-row>
                            <b-row style="margin-top: 27px">
                                <b-col class="flex_col-mobile">
                                    <b-button class="mr-2 text-uppercase" variant="custom-white" v-on:click="getImportSubstitutionRequests(false)">Найти</b-button>
                                    <b-button class="mr-2 text-uppercase" variant="custom-outline-light" v-on:click="showOtherFilter">Все фильтры</b-button>
                                    <b-button class="mr-2 text-uppercase" variant="custom-outline-light" v-on:click="clearFilter"> Сбросить</b-button>
                                    <b-button class="mr-2 text-uppercase" variant="custom-outline-light" v-on:click="copyUrlWithFilters">Скопировать ссылку на фильтр</b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-container>
            </b-form>
        </b-container>
        <b-container fluid>
            <b-container>
                <b-row>
                    <b-col>
                        <ul v-if="!mobileMenu" class="category_menu">
                            <li v-for="(category, cIndex) in importSubstitutionStatuses" :key="'category_' + cIndex">
                                <router-link :to="{ name: 'ImportSubstitutionRequestsList', params: { path: category.path } }">
                                    {{ category.title }}
                                </router-link>
                            </li>
                        </ul>
                        <div v-if="mobileMenu">
                            <p v-b-toggle="'purchase_category'" class="fs-14 fw-600 my-3 green-color d-flex justify-content-between">
                                {{ activeTab[0].title }}
                                <i :class="{ 'fa-chevron-down': !mobileMenu_show, 'fa-chevron-up': mobileMenu_show }" class="fa fs-14 fw-600 green-color d-flex align-items-center"></i>
                            </p>
                            <b-collapse id="purchase_category" v-model="mobileMenu_show">
                                <ul class="mobile_category_menu">
                                    <li v-for="(category, cIndex) in importSubstitutionStatuses" :key="'category_' + cIndex" v-on:click="changeCategory(category.path)">
                                        {{ category.title }}
                                    </li>
                                </ul>
                            </b-collapse>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-container id="content-block" class="greyBg" fluid style="border-top: 2px solid lightgray">
            <b-container v-if="importSubstitutionRequests.length">
                <div style="width: 100%">
                    <b-pagination v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" style="padding-bottom: 0" />
                </div>
            </b-container>
            <b-container v-for="importSubstitutionRequest in importSubstitutionRequests" :key="importSubstitutionRequest.id" style="margin-top: 29px">
                <b-row>
                    <import-substitution-card-open v-if="importSubstitutionRequest.status_id === 1" :importSubstitutionRequest="importSubstitutionRequest" @reloadData="getImportSubstitutionRequests" />
                    <import-substitution-card-closed v-if="importSubstitutionRequest.status_id === 2" :importSubstitutionRequest="importSubstitutionRequest" />
                </b-row>
            </b-container>
            <b-container v-if="!loading && !importSubstitutionRequests.length">
                <empty-request></empty-request>
            </b-container>
            <b-container v-if="importSubstitutionRequests.length">
                <div style="width: 100%">
                    <b-pagination v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" @input="getImportSubstitutionRequests()" />
                </div>
            </b-container>
        </b-container>
        <system-preloader v-if="loading"></system-preloader>

        <!--  Используется для копирования ссылок с параметрами  -->
        <input id="myInput" class="hidden" style="display: none" type="text" value="" />
        <router-link id="copy_link" :to="{ name: 'ImportSubstitutionRequestsList', params: { order: current_route }, query: buildQueries() }" class="copy_link hidden" exact style="display: none"> Информация о закупке </router-link>
        <!--  Используется для копирования ссылок с параметрами  -->
    </div>
</template>

<script>
import { __PURCHASE_STATUS } from '@/const';
import ImportSubstitutionCardOpen from './import-substitution-card-open';
import ImportSubstitutionCardClosed from './import-substitution-card-closed';
import FilterMultipleSelect from '@/components/common/filter-components/filter-multiple-select';

export default {
    name: 'ImportSubstitutionRequestsList',
    components: {
        FilterMultipleSelect,
        ImportSubstitutionCardOpen,
        ImportSubstitutionCardClosed
    },
    metaInfo: {
        title: 'Импортозамещение'
    },
    data() {
        return {
            mobileMenu_show: false,
            mobileMenu: false,
            filter: {
                purchaseCategories: [],
                ktruName: '',
                orderDateStart: null,
                orderDateFinish: null
            },
            current_route: null,
            importSubstitutionStatuses: [
                { title: 'Все', path: 'all', status: '' },
                { title: 'Прием предложений открыт', path: 'open', status: 1 },
                { title: 'Прием предложений завершен', path: 'closed', status: 2 }
            ],
            loading: true,
            importSubstitutionRequests: [],
            showFilters: false,
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false
            },
            meta: {
                current_page: 1,
                total: 0,
                per_page: 1
            },
            activeTabText: '',
            email: this.$store.state.user && this.$store.state.user.email ? this.$store.state.user.email : ''
        };
    },
    mounted() {
        document.documentElement.addEventListener('keydown', this.KeyEnterFilter);
    },
    async created() {
        this.PURCHASE_STATUS = __PURCHASE_STATUS;
        window.innerWidth <= 767 ? (this.mobileMenu = true) : (this.mobileMenu = false);
        this.current_route = this.$route.params.path;
        this.getImportSubstitutionRequests();
    },
    destroyed() {
        document.documentElement.removeEventListener('keydown', this.KeyEnterFilter);
    },
    computed: {
        activeTab() {
            return this.importSubstitutionStatuses.filter((category) => {
                return category.path.match(this.current_route);
            });
        }
    },
    methods: {
        buildQueries() {
            let queries = {};
            queries.filter = JSON.stringify(this.filter);
            return queries;
        },
        copyUrlWithFilters() {
            let routerLink = document.getElementById('copy_link');
            let copyText = document.getElementById('myInput');
            routerLink.style.display = 'block';
            copyText.style.display = 'block';
            copyText.value = routerLink.href;
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
            routerLink.style.display = 'none';
            copyText.style.display = 'none';
            this.pushToast({
                text: 'Ссылка сохранена',
                title: 'Успех',
                variant: 'green'
            });
        },
        changeCategory(id) {
            this.$router.push({ name: 'ImportSubstitutionRequestsList', params: { path: id } }).catch(() => {});
            this.mobileMenu_show = false;
        },
        showOtherFilter(e) {
            this.showFilters = !this.showFilters;
            this.subject = [];
            this.showFilters ? (e.target.innerText = 'Меньше фильтров') : (e.target.innerText = 'Все фильтры');
        },
        clearFilter() {
            this.$refs.filter.reset();
            this.filter = {
                purchaseCategories: [],
                ktruName: '',
                orderDateStart: null,
                orderDateFinish: null
            };
            this.getImportSubstitutionRequests(false);
        },
        KeyEnterFilter(e) {
            if (e.keyCode === 13) {
                this.getImportSubstitutionRequests(false);
            }
        },
        getStatus() {
            return this.importSubstitutionStatuses.find((x) => x.path === this.current_route).status;
        },
        getFilters(page = true) {
            return {
                filter: { ...this.filter },
                status: this.getStatus(),
                page: page ? this.meta.current_page : 1
            };
        },
        getImportSubstitutionRequests(page = true, loading = true) {
            this.loading = loading;
            this.$api.importSubstitutionRequests
                .fetchWithFilters(this.getFilters(page))
                .then((importSubstitutionRequests) => {
                    this.importSubstitutionRequests = importSubstitutionRequests.data;
                    this.meta = importSubstitutionRequests.meta;
                    this.$scrollToTop();
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    watch: {
        $route: function (to) {
            this.current_route = to.params.path;
            this.loading = true;
            this.getImportSubstitutionRequests(false);
        }
    },
    beforeRouteEnter: function (to, from, next) {
        if (Object.keys(to.query).length > 0) {
            next((vm) => {
                let path = to.params.path;
                let queries = to.query;
                vm.filter = JSON.parse(queries.filter);
                vm.$router.replace('/import_substitution/' + path).catch(() => {});
            });
        } else {
            next();
        }
    }
};
</script>

<style scoped>
.m-b-22 {
    margin-bottom: 22px;
}

.halfWhite-color {
    color: rgba(255, 255, 255, 0.5);
}

.main_layer {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    /*min-height: 350px;*/
    min-height: 150px;
}

.category_menu {
    padding: 0;
    margin-bottom: -2px;
    margin-top: 14px;
    list-style-type: none;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
}

.category_menu li {
    padding-bottom: 9px;
}

.category_menu li + li {
    margin-left: 20px;
}

.category_menu li a {
    font-size: 14px;
    color: var(--grey-color);
    border-bottom: 2px solid transparent;
    text-decoration: none;
    padding-bottom: 11px;
    white-space: nowrap;
}

.router-link-active {
    color: var(--green-color) !important;
    border-bottom-color: var(--green-color) !important;
    font-weight: 600;
}

.show_bg {
    background-color: #f5f5f7;
}

.purchase_part {
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border: 1px solid #d9d9de;
}

.purchase_part-header {
    -webkit-border-radius: 4px 4px 0 0;
    -moz-border-radius: 4px 4px 0 0;
    border-radius: 4px 4px 0 0;
    background-color: var(--green-color);
    padding: 10px 24px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.purchase_part-body {
    padding: 20px 24px;
}

.purchase_part-header_number {
    font-size: 14px;
    color: #fff;
    margin: 0;
    font-weight: 600;
}

.purchase_part-header_label {
    text-transform: uppercase;
    color: #fff;
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 12px;
}

.purchase_part-body_col + .purchase_part-body_col > div::before {
    content: '';
    width: 1px;
    height: 100%;
    position: absolute;
    background-color: #d9d9de;
    left: 0px;
}

.mobile_category_menu {
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
}

.mobile_category_menu li {
    padding: 10px 0;
}

.mobile_category_menu li + li {
    border-top: 1px solid var(--green-color);
}

.head-visible_mobile {
    display: none;
}

@media screen and (max-width: 1200px) {
    .head-visible_mobile {
        display: block;
    }

    .less_font-size_mobile {
        font-size: 40px !important;
    }
}

@media screen and (max-width: 767px) {
    .purchase_part-body {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .purchase_part-body_col > div::before {
        display: none;
    }

    .hidden-mobile {
        display: none;
    }

    .row-mobile {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
    }

    .time_to_end {
        font-size: 12px !important;
        margin-bottom: 0 !important;
        /*margin-left: 5px !important;*/
    }

    /*.purchase_status {*/
    /*  margin-left: 5px !important;*/
    /*}*/
}

@media screen and (max-width: 414px) {
    .flex_col-mobile {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
}

@media screen and (max-width: 320px) {
    .less_font-size_mobile {
        font-size: 38px !important;
    }
}
</style>

<style lang="less">
@subtext-color: #777;
@preloader-bg-color: rgba(255, 255, 255, 0.75);
@suggestions-bg-color: #fff;
@subtext-label-color: #f5f5f5;

.box-sizing(@sizing: border-box) {
    -ms-box-sizing: @sizing;
    -moz-box-sizing: @sizing;
    -webkit-box-sizing: @sizing;
    box-sizing: @sizing;
}

.rounded(@radius) {
    -webkit-border-radius: @radius;
    -moz-border-radius: @radius;
    border-radius: @radius;
}

.cross-button-mixin() {
    @cross-padding: 20;
    @cross-ray-width: 10;
    @cross-ray-length: 50 - @cross-padding - @cross-ray-width;
    @svg: "<svg width='100' height='100' xmlns='http://www.w3.org/2000/svg'><g><path d='m@{cross-padding},@{cross-padding}m@{cross-ray-width},0l@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},-@{cross-ray-width}l@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},-@{cross-ray-width}' fill='#999'/></g></svg>";
    @svg64: `new Buffer(@{svg}) .toString('base64') `;
    background: transparent url('data:image/svg+xml;base64,@{svg64}') 50% 50% no-repeat;
    background-size: contain;

    cursor: pointer;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}

.suggestions-nowrap {
    white-space: nowrap;
}

/**
     * Основной INPUT
     */
.suggestions-input {
    // IE9 can't determine border-style until it is specified in stylesheets
    //  border: 1px solid grey;
    .box-sizing();
    width: 100%;

    &::-ms-clear {
        display: none;
    }
}

.suggestions-wrapper {
    position: relative;
    margin: 0;
    padding: 0;
    vertical-align: top;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;
}

/**
     * Блок в правой части основного INPUT'а
     * В нем показывается иконка ЗАГРУЗКА
     */
.suggestions-addon {
    display: none;
    opacity: 0;
    position: absolute;

    &[data-addon-type='spinner'] {
        background: @preloader-bg-color
            url('data:image/gif;base64,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')
            50% 50% no-repeat;
        .rounded(50%);
    }

    &[data-addon-type='clear'] {
        .cross-button-mixin();
    }
}

/**
     * Выпадающий блок с найденными подсказками
     */
.suggestions-suggestions {
    background: @suggestions-bg-color;
    border: 1px solid #999;
    .box-sizing;
    cursor: default;
    z-index: 990;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;

    strong {
        font-weight: normal;
        color: #3399ff;
    }

    &.suggestions-mobile {
        border-style: none;

        .suggestions-suggestion {
            border-bottom: 1px solid #ddd;
        }
    }
}

/**
     * Контейнер для одной подсказки
     */
.suggestions-suggestion {
    padding: 4px 4px;
    overflow: hidden;

    &:hover {
        background: darken(@suggestions-bg-color, 3%);
    }
}

/**
     * Выбранная (активная) подсказка
     */
.suggestions-selected {
    background: darken(@suggestions-bg-color, 6%);

    &:hover {
        background: darken(@suggestions-bg-color, 6%);
    }
}

/**
     * Информационный блок в верхней части выпадашки с подсказками
     */
.suggestions-hint {
    padding: 4px 4px;
    white-space: nowrap;
    overflow: hidden;
    color: @subtext-color;
    font-size: 85%;
    line-height: 20px;
}

/**
     * Ограничения поиска, показываются в левой части основного INPUT'а
     */
.suggestions-constraints {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap !important;

    &:empty {
        display: none !important;
    }

    li {
        background: #f8f8f8;
        border: 1px solid #ccc;
        .rounded(3px);
        cursor: default;
        display: inline-block;
        margin: 0 4px 0 0;
        padding: 0 0.5em;

        .suggestions-remove {
            @icon-size: 1em;
            height: @icon-size;
            width: @icon-size;
            display: inline-block;

            margin: 0 0 0 0.25em;
            .cross-button-mixin();
        }

        span {
            vertical-align: middle;
        }
    }
}

/**
     * Дополнительный текст в подсказке, который идет второй строкой
     */
.suggestions-subtext {
    color: @subtext-color;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/**
     * Размещает дополнительный текст в одну строку с основным текстом подсказки
     */
.suggestions-subtext_inline {
    display: inline-block;
    min-width: 6em;
    vertical-align: bottom;
    margin: 0 0.5em 0 0;
}

/**
     * Разделитель нескольких дополнительных текстов
     */
.suggestions-subtext-delimiter {
    display: inline-block;
    width: 2px;
}

/**
     * Выделяет подсказку
     */
.suggestions-subtext_label {
    margin: 0 0 0 0.25em;
    .rounded(3px);
    padding: 0 3px;

    background: @subtext-label-color;
    font-size: 85%;
}

.suggestions-value {
    &[data-suggestion-status='LIQUIDATED'] {
        position: relative;

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;

            border-top: 1px solid rgba(0, 0, 0, 0.4);

            content: '';
        }
    }
}

/**
     * Промо-блок
     */
.suggestions-promo {
    font-size: 85%;
    display: none;
    color: @subtext-color;
    padding: 4px;
    text-align: center;

    a {
        color: @subtext-color;
        display: block;
        filter: grayscale(100%);
        line-height: 20px;
        text-decoration: none;
    }

    a:hover {
        filter: grayscale(0);
    }

    svg {
        height: 20px;
        vertical-align: bottom;
    }
}

.suggestions-promo-desktop {
    position: absolute;
    top: 0;
    right: 0;
    text-align: left;
}

.b-form-datepicker {
    color: rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, 0.2);
    border: none !important;
}

.b-form-datepicker > .btn,
.b-form-datepicker > label {
    color: rgba(255, 255, 255, 0.7) !important;
}
</style>
